// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.search-icon {
  margin-left: 10px;
  background-color: #333742;
  padding: 10px 13px;
  color: rgb(210, 207, 207);
  border-radius: 16%;
  cursor: pointer;
}
.search-icon:hover {
  color: white;
  background-color: #3B71CA;
  transition: all 0.4s ease-in-out;
}`, "",{"version":3,"sources":["webpack://./src/app/features/secure-blockchain/authoring-tools/smart-contract-view/smart-contract-view-keys/smart-contract-view-keys.component.scss"],"names":[],"mappings":"AAAA;EACE,iBAAA;EACA,yBAAA;EACA,kBAAA;EACA,yBAAA;EACA,kBAAA;EACA,eAAA;AACF;AACE;EACE,YAAA;EACA,yBAAA;EACA,gCAAA;AACJ","sourcesContent":[".search-icon {\n  margin-left: 10px;\n  background-color: #333742;\n  padding: 10px 13px;\n  color: rgb(210, 207, 207);\n  border-radius: 16%;\n  cursor: pointer;\n\n  &:hover {\n    color: white;\n    background-color: #3B71CA;\n    transition: all 0.4s ease-in-out;\n  }\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
